import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2, Feather } from "lucide-react";
import { toast } from "sonner";
import { api, setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      toast.error("Missing session id");
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/google-callback", {
          session_id: sessionId,
        });
        setToken(data.token);
        setUser(data.user);
        // clear the hash so returning to this URL doesn't retry
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${data.user.name || "friend"}!`);
        navigate("/app", { replace: true });
      } catch (err) {
        toast.error(
          err?.response?.data?.detail || "Could not complete Google sign-in"
        );
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FAF9F5]">
      <div
        data-testid="auth-callback-loading"
        className="flex flex-col items-center gap-3 text-slate-600"
      >
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#1A1D20] text-[#FAF9F5]">
          <Feather className="h-4 w-4" />
        </div>
        <div className="flex items-center gap-2 text-sm">
          <Loader2 className="h-4 w-4 animate-spin" />
          Signing you in with Google…
        </div>
      </div>
    </div>
  );
}
